import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AppBar, Button, Typography, Avatar, Toolbar, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import decode from 'jwt-decode';
import { AUTH_ACTION } from '../../interface';
import useStyles from './styles';
import appBarLogo from '../../assets/logo/logo.png';
import useMedia from "use-media";
// import useCommonStyles from '../CommonStyle/commonStyle';
import PopModal from '../PopModal/PopModal';
// import { Container } from 'react-bootstrap';
import { store } from '../../index';
import SUSTAINABLE_LOGO from '../../assets/logo/sustainable_games_logo.svg';

type RootState = ReturnType<typeof store.getState>;

const Navbar = () => {
    const { loggedIn } = useSelector((state: RootState) => state.auth);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}'));
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const classes = useStyles();
    // const commonClasses = useCommonStyles();
    const [open, setOpen] = React.useState(false);

    // const released = false;
    const handleOpen = () => {
        setOpen(true);
    };
    // const handleClose = () => {
    //     setOpen(false);
    // };

    console.log(location);
    const logout = () => {
        dispatch({ type: AUTH_ACTION.LOGOUT });
        setUser({ result: { name: "", imageUrl: "" } });
        history.push('/');


    };

    useEffect(() => {
        const token = user?.token;

        if (token) {
            const decodedToken = decode(token);
            console.log("checking token time");
            //@ts-ignore
            if (decodedToken.exp * 1000 < new Date().getTime()) {
                console.log("logging out");
                logout()};
        }

        setUser(JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}'));
    }, [location]);

    const isLarger820 = useMedia({ minWidth: "820px" });
    return (
        <AppBar className={isLarger820 ? classes.appBar : classes.appBarSmall} position="static" color="inherit">
            <div className={classes.brandContainer} >
                {/* <Typography component={props => <Link {...props} />} className={classes.heading} variant="h2" align="center" to='/'>Flare</Typography> */}
                <Link to="/">
                    <img className={classes.image} src={appBarLogo} alt="appBarLogo" height="30" />
                </Link>
                {isLarger820 ? <>
                    <Typography display="inline" variant="body1" className={classes.bySustainableGames}>by</Typography>
                    <img className={classes.logo} src={SUSTAINABLE_LOGO} alt="Sustainable" />
                </> : <></>}
            </div>
            <Toolbar className={classes.toolbar}>
                {
                    loggedIn ? (
                        <Grid container direction="row" alignItems="center" justifyContent="flex-end">
                            <Grid item>
                                <Link to="/projects/form" className={classes.projectFormBtn}>プロジェクトを投稿</Link>
                                <Link to="/projects" className={classes.projectsBtn}>プロジェクトを探す</Link>
                            </Grid>
                            <Grid item className={classes.profile}>
                                <Avatar className={classes.avatar} alt={user.result.name} src={user.result.imageUrl}>{user.result.name.charAt(0)}</Avatar>
                                {/* <Typography className={classes.userName} variant="h6">{user.result.name}</Typography> */}
                                <Button variant="contained" className={classes.purple} color="secondary" onClick={logout}>ログアウト</Button>
                            </Grid>
                        </Grid>


                    ) : (

                        <>
                            {isLarger820 ? (<>
                                {process.env.REACT_APP_STAGE !== 'prod' ? (
                                    <>
                                        <Link to="/startup/login" className={classes.loginBtn}>ログイン</Link>
                                        <Link to="/startup/signup" className={classes.signupBtn}>新規登録</Link>
                                    </>
                                ) : (
                                    <>
                                        <Link to="#" className={classes.loginBtn} onClick={handleOpen}>ログイン</Link>
                                        <Link to="#" className={classes.signupBtn} onClick={handleOpen}>新規登録</Link>
                                    </>)
                                }

                            </>) : (<></>)}
                            {location.pathname === "/enterprise" ?
                                <Button component={Link} to="/startup" variant="contained" color="secondary" className={classes.industryDir}>個人向けページヘ</Button> :
                                <Button component={Link} to="/enterprise" variant="contained" color="primary" className={classes.startupDir}>企業向けページヘ</Button>
                            }
                        </>
                    )
                }
            </Toolbar>
            <PopModal setOpen={setOpen} open={open} />
        </AppBar>
    )
}

export default Navbar;